import { fetchdata } from 'apis/FetchData';
import { handle420 } from 'apis/HandleError';

export function getProvisionSuActionStatus(url) {
  return fetchdata(url, { method: 'GET' })
    .then((result) => {
      return result;
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
}
